import { Component, OnInit } from '@angular/core';
import {SearchRobinsonService} from '../../services/search-robinson.service';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {AuthService} from '../../../../core/service/auth.service';

@Component({
  selector: 'app-search-robinson',
  templateUrl: './search-robinson.component.html',
  styleUrls: ['./search-robinson.component.scss']
})
export class SearchRobinsonComponent implements OnInit {

    enabled: boolean = false;
    availablePortals: Array<string> = [];
    formSearch: FormGroup;
    result: Array<Object> = [];

    constructor(private robinson: SearchRobinsonService, private fb: FormBuilder, private auth: AuthService) {

        this.formSearch = this.fb.group({
            'email': new FormControl(),
            'phone_mobile' : new FormControl(),
            'phone_landline' : new FormControl(),
            'name': new FormControl(),
            'first_surname' : new FormControl(),
            'last_surname' : new FormControl(),
            'street_name' : new FormControl(),
            'street_number' : new FormControl()
        });
    }

    searchRobinson(): void {
        this.enabled = true;
        this
            .robinson
            .searchRobinson(this.auth.getPortalSelected().portal, this.formSearch.value)
            .subscribe(
                (r) => {
                    this.result = r;
                    this.enabled = false;
                }
            )
        ;
    }

    isAvailableForPortal(): boolean {
        const idx = this.availablePortals.findIndex( (portal) => {
            return (portal == this.auth.getPortalSelected().portal);
        } );

        return idx >= 0;
    }

    ngOnInit() {
        this.enabled = true;
        this.robinson.getAvailableCountries().subscribe(
            (result) => {
                this.availablePortals = result;
                this.enabled = false;
            }
        )
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/robinson/search/components/search-robinson/search-robinson.component.ts